"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Container = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.header `
	height: 80px;
	background: ${({ theme }) => `${theme.white} 0% 0% no-repeat padding-box`};
	box-shadow: 0px 2px 2px ${({ theme }) => theme.blackContainer};
	font-size: ${({ theme }) => theme.baseFontSize};
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	.home-link {
		text-decoration: none;
		color: ${({ theme }) => theme.textBlack};
	}

	@media (max-width: 41em) {
		height: ${({ burgerOpen }) => (burgerOpen ? "170px" : "80px")};
		align-items: ${({ burgerOpen }) => (burgerOpen ? "flex-start" : "center")};
		margin-top: 0px;
	}

	@media (max-width: 260px) {
		.home-link {
			font-size: 0!important;
		}
	}

	.left-side {
		height: 80px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background-color: ${({ theme }) => theme.white};
		border: none;
		font-family: 'AkkuratStd-Light', Helvetica, sans-serif;
		font-size: 16px;

		img {
			padding-left: 20px;
			padding-right: 10px;
		}

		p {
			color: ${({ theme }) => theme.textBlack};
		}

		@media only screen and (max-width: 260px) {
			display: block;

			img {
				margin-top: 12px;
				padding-left: 10px;
			}
		}
	}

	.right-side {
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-right: 20px;
		position: relative;

		.links {
			display: flex;
			flex-direction: row;
			list-style-type: none;

			a {
				padding: 14px 25px;
				color: ${({ theme }) => theme.denimBlue};
				font-size: ${({ theme }) => theme.baseFontSize};
				height: 20px;
				line-height: 20px;
			}
		}

		.burger-button {
			display: none;
			background-color: ${({ theme }) => theme.white};
			border: none;
		}

		@media (max-width: 41em) {
			padding-right: 0;

			a {
				display: none;
			}

			.links {
				flex-direction: column;
				position: absolute;
				right: 0px;
				top: 80px;
				padding: 0px 20px;
				text-align: right;
				white-space: nowrap;
				margin: 0;

				a {
					margin-right: 0px;
					padding: 13px 0;
				}
			}

			.open {
				display: block;
			}

			.burger-button {
				height: 100%;
				width: 80px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}

			.bar1,
			.bar2,
			.bar3 {
				width: 25px;
				height: 0px;
				border-top: ${({ theme }) => `3px solid ${theme.denimBlue}`};
				margin: 3px 0;
				transition: 0.4s;
			}

			/* Rotate first bar */
			.open .bar1 {
				-webkit-transform: rotate(-45deg) translate(-6px, 7px);
				transform: rotate(-45deg) translate(-6px, 7px);
			}

			/* Fade out the second bar */
			.open .bar2 {
				opacity: 0;
			}

			/* Rotate last bar */
			.open .bar3 {
				-webkit-transform: rotate(45deg) translate(-6px, -7px);
				transform: rotate(45deg) translate(-6px, -7px);
			}
		}

		@media (max-width: 260px) {
			position: absolute;
			right: 0;
		}
	}
`;
const SkipLink = styled_components_1.default.a `
	position: absolute;
	background: ${({ theme }) => theme.white};
	top: 10px;
	left: -15000px;
	:focus {
		outline-offset: 2px;
		outline: 2px solid black;
		left: 60px
	}
`;
const Header = ({ config: { logo, links, translatedKeys } }) => {
    const history = react_router_dom_1.useHistory();
    const [burgerClass, setBurgerClass] = react_1.useState("burger-button");
    const [burgerOpen, setBurgerOpen] = react_1.useState(false);
    function focusOnMainContent(e) {
        var _a;
        e.preventDefault();
        e.stopPropagation();
        (_a = document.getElementById('main-content')) === null || _a === void 0 ? void 0 : _a.focus();
    }
    function handleClick(e, url) {
        e.preventDefault();
        e.stopPropagation();
        return window.open(url, "_blank");
    }
    function homeRedirect(e) {
        e.preventDefault();
        e.stopPropagation();
        history.push(links.home);
    }
    function burgerToggle() {
        burgerOpen ? setBurgerClass("burger-button") : setBurgerClass("burger-button open");
        setBurgerOpen(previous => !previous);
    }
    return (react_1.default.createElement(exports.Container, { burgerOpen: burgerOpen },
        react_1.default.createElement(SkipLink, { href: "#main", onClick: focusOnMainContent, "data-testid": "skip-link" }, translatedKeys.skipLink),
        react_1.default.createElement("a", { href: '#', "aria-label": translatedKeys.homePageAriaLabel, className: "left-side home-link", onClick: homeRedirect },
            react_1.default.createElement("img", { src: logo, alt: translatedKeys.logoAlt }),
            translatedKeys.logoText),
        react_1.default.createElement("nav", { className: "right-side" },
            react_1.default.createElement("button", { className: burgerClass, "aria-expanded": burgerOpen, onClick: burgerToggle, "aria-label": burgerOpen
                    ? translatedKeys.closeNav
                    : translatedKeys.navMenu, "data-testid": "burger" },
                react_1.default.createElement("span", { className: "bar1" }),
                react_1.default.createElement("span", { className: "bar2" }),
                react_1.default.createElement("span", { className: "bar3" })),
            react_1.default.createElement("ul", { className: "links" },
                react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { className: burgerOpen ? 'open' : '', href: links.support, onClick: (e) => handleClick(e, links.support), "data-testid": "support-link" }, translatedKeys.support)),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { className: burgerOpen ? 'open' : '', href: links.contact, onClick: (e) => handleClick(e, links.contact), "data-testid": "contact-link" }, translatedKeys.contactUs))))));
};
exports.Header = Header;
